<template lang="html">
  <div class="img-wrapper">
    <img v-for="(image, index) in imageSources"
         :src="image" :alt="`csepel-photo-${index}`"
         @click="openImage(index)">
   <imageViewerPopup v-if="selectedImage"
                  :selectedImage="selectedImage"
                  @close="closeDialog"></imageViewerPopup>
  </div>
</template>

<script>
import imageViewerPopup from './imageViewerPopup.vue'
export default {
  name: 'imageGrid',
  props: ['imageList'],
  components: {imageViewerPopup},
  data: function () {
    return {
      selectedImage: null
    }
  },
  methods: {
    openImage(index) {
      this.selectedImage = this.imageList[index]
    },
    closeDialog () {
      this.selectedImage = null
    },
  },
  computed: {
    imageSources() {
      return this.$store.getters['config/getUrlsForImageGrid'](this.imageList)
    }
  }
}
</script>

<style scoped>
  .img-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 100vh;
  }
  img {
    width: calc(100% / 3);
    height: calc(100vh / 3);
    object-fit: cover;
    opacity: 0.8;
    cursor: pointer;
  }

  @media (max-width: 640px) {
    .img-wrapper {
      height: auto;
    }

    img {
      width: calc(100% / 2);
      height: calc(100vh / 5);
    }

    img:last-of-type {
      display: none;
    }
  }
</style>
